import cryptoJS from 'crypto-js'

/**
 * des 加密
 */

export const encryptDes = (message, key='6aNSV5pZeHTYmj6UMvpU78s7iFwzzk1P9ULhW2KAWAOjB6KZF1s5OLWmhTUjwLg8jcli42zHJqAvZAZbTSdX23yi6tDHby5Z6dO', iv='01234567') => {
    var keyHex = cryptoJS.enc.Utf8.parse(key);
    var encrypted = cryptoJS.TripleDES.encrypt(message, keyHex, {
      iv: cryptoJS.enc.Utf8.parse(iv),
      mode: cryptoJS.mode.CBC,
      padding: cryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
}

/**
 * des 解密
 */

export const decryptDes = (ciphertext, key='6aNSV5pZeHTYmj6UMvpU78s7iFwzzk1P9ULhW2KAWAOjB6KZF1s5OLWmhTUjwLg8jcli42zHJqAvZAZbTSdX23yi6tDHby5Z6dO', iv='01234567') => {
    var keyHex = cryptoJS.enc.Utf8.parse(key);
    var decrypted = cryptoJS.TripleDES.decrypt({
      ciphertext: cryptoJS.enc.Base64.parse(ciphertext)
    }, keyHex, {
        iv: cryptoJS.enc.Utf8.parse(iv),
        mode: cryptoJS.mode.CBC,
        padding: cryptoJS.pad.Pkcs7
      });
    return decrypted.toString(cryptoJS.enc.Utf8);
}


// WEBPACK FOOTER //
// ./src/crypto/crypto.js